import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";

@Injectable({ providedIn: "root" })
export class SalesContractFolderAttachmentHdrService extends BaseApiTemplateService<any> {
  static readonly SALES_CONTRACT_FOLDER_HDR_SUBPATH =
    "sales-contract-folder-attachment-hdrs/";

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractFolderAttachmentHdrService.SALES_CONTRACT_FOLDER_HDR_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      Core2Config.FI_PREFIX +
      SalesContractFolderAttachmentHdrService.SALES_CONTRACT_FOLDER_HDR_SUBPATH +
      BaseApiTemplateService.BACKOFFICE_EP;
    this.httpClient = http;
  }

  public getAttachmentFile(
    extensionGuid: string,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    let url;
    if (this.endpoint_path && apiVisa.api_domain_url) {
      url =
        apiVisa.api_domain_url +
        Core2Config.TENANT_DOMAIN_URL_PREFIX +
        Core2Config.ERP_PREFIX +
        Core2Config.FI_PREFIX +
        SalesContractFolderAttachmentHdrService.SALES_CONTRACT_FOLDER_HDR_SUBPATH +
        "/file/" +
        BaseApiTemplateService.BACKOFFICE_EP +
        "/" +
        extensionGuid;
    }
    return this.httpClient.get<Blob>(url, this.getHttpHeaderBlob(apiVisa));
  }
}
